import { render, staticRenderFns } from "./Docs.vue?vue&type=template&id=08281f8c&scoped=true&lang=pug&"
import script from "./Docs.vue?vue&type=script&lang=ts&"
export * from "./Docs.vue?vue&type=script&lang=ts&"
import style0 from "./Docs.vue?vue&type=style&index=0&id=08281f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08281f8c",
  null
  
)

export default component.exports